<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import WrongRecipientAppointmentCell from "./_modules/wrong-recipient-appointment-cell"
  import type { WrongRecipientReplacementDraft, WrongRecipientReplacementRow } from "../../contract"

  let props: InboxWorkflowCellProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> =
    $props()

  const row = $derived(props.row)
</script>

<WrongRecipientAppointmentCell
  presentation={row.appointmentPresentation}
  disabled={props.disabled}
/>
